module.exports = __webpack_public_path__ + "static/media/3DPPA25.60ff0cc2.jpg";